import { render, staticRenderFns } from "./LiefengModal.vue?vue&type=template&id=2f886381&"
import script from "./LiefengModal.vue?vue&type=script&lang=js&"
export * from "./LiefengModal.vue?vue&type=script&lang=js&"
import style0 from "./LiefengModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports